import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function AnimatedText() {
  const [index, setIndex] = useState(0);

  const phrases = [
    "Menos problemas.\nMás juerga.",
    "Tu noche.\nA otro nivel.",
    "Acceso rápido.\nSin filas.",
    "La infraestructura.\nQue mereces.",
  ];

  useEffect(() => {
    // Cambiamos el texto cada 4 segundos
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [phrases.length]);

  // Variantes de animación para controlar el contenedor y los hijos
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15, // Retraso entre líneas (Efecto cascada)
        delayChildren: 0.1,    // Pequeña pausa antes de empezar
      },
    },
    exit: {
      opacity: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1, // Salen en orden inverso
      },
    },
  };

  const childVariants = {
    hidden: { 
      opacity: 0, 
      y: 20,          // Empieza 20px abajo
      filter: "blur(10px)" // Empieza borroso
    },
    visible: { 
      opacity: 1, 
      y: 0,           // Sube a su sitio
      filter: "blur(0px)", // Se enfoca
      transition: { 
        duration: 0.8, 
        ease: [0.2, 0.65, 0.3, 0.9] // Curva Bezier personalizada (muy suave)
      }
    },
    exit: { 
      opacity: 0, 
      y: -20,         // Se va hacia arriba
      filter: "blur(10px)", // Se desenfoca al salir
      transition: { duration: 0.5 } 
    }
  };

  // Dividimos la frase actual en líneas
  const currentLines = phrases[index].split('\n');

  return (
    <div className="flex flex-col justify-center min-h-[160px] md:min-h-[220px]">
      <AnimatePresence mode="wait">
        <motion.div
          key={index} // La clave es vital para que AnimatePresence detecte el cambio
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {currentLines.map((line, i) => {
            const isLastLine = i === currentLines.length - 1;
            
            return (
              <motion.span
                key={i}
                variants={childVariants}
                className={`
                  block leading-tight
                  ${isLastLine 
                    ? 'font-serif italic text-white/90 text-6xl md:text-8xl mt-2' // Estilo elegante
                    : 'font-sans font-light text-white text-5xl md:text-7xl tracking-tighter' // Estilo moderno
                  }
                `}
              >
                {line}
              </motion.span>
            );
          })}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}